import { Box, BoxProps, Toolbar } from '@mui/material';
import { useContext } from 'react';
import { IncPageContext } from '../inc-page.context';

type IncPageBodyProps = {
  children?: React.ReactNode;
  'data-testid'?: string;
} & BoxProps;

const IncPageBody = ({
  children,
  'data-testid': dataTestId = 'IncPageBody',
  sx,
  ...rest
}: IncPageBodyProps) => {
  const { hasFooter } = useContext(IncPageContext);

  return (
    <Box
      p={2}
      data-testid={dataTestId}
      flexGrow={1}
      sx={{
        '.field-container': { maxWidth: 1000 },
        '.field-inner-container': { maxWidth: [320, 480] },
        ...sx,
      }}
      {...rest}
    >
      {children}
      {hasFooter && <Toolbar />}
    </Box>
  );
};

export default IncPageBody;
